export const paymentsCollectionGuard = 'GET /v2/payments';
export const paymentsResourceGuard = 'GET /v2/payments/d+';
export const paymentsRegExpCollectionGuard = 'GET /v2/payments/[a-zA-Z0-9- ]+';
export const editPaymentsResourceGuard = 'PUT /v2/payments/d+';
export const createPaymentsResourceGuard = 'POST /v2/payments';
export const deletePaymentsResourceGuard = 'DELETE /v2/payments/d+';
